/**
 * EITS-Orquestrador-BR
 * Disponibiliza as operações centrais do SerasaJud
 *
 * OpenAPI spec version: 1.0.0
 * Contact: squadnegativamente@br.experian.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Lote } from './lote';
import { Credor } from 'src/app/core/apis/orchestrador/model/solicitacao/credor';
import { TitularOrdem } from './titularOrdem';
import { Vara } from './vara';
import { VaraMagistrado } from './varaMagistrado';


export interface Ordem {
    id?: number;
    nroProcesso?: string;
    nroOrdem?: number;
    anoOrdem?: number;
    autor?: string;
    reu?: string;
    nroSla?: number;
    status?: Ordem.StatusEnum;
    tpOrdem?: Ordem.TpOrdemEnum;
    dtaAnotacao?: Date;
    nroDocumentoServidor?: string;
    nomeServidor?: string;
    titularPrincipal?: string;
    vara?: Vara;
    varaMagistrado?: VaraMagistrado;
    titulares?: Array<TitularOrdem>;
    credores?: Array<Credor>;
    lote?: Lote;
    decricaoOrdem?: string;
    usuarioCadastro?: any;
    statusFormatado?: string;
    tpOrdemFormatado?: string;
    sistemaOrigem?: string;
    arquivoOficioEnvio?: string;
    arquivoOficioResposta?: string;
    nomeArquivoEnvio?: string;
    acao?: any;
    baixa?: any;
    motivoCancelamento?: string;
    cartaComunicado?: boolean;
}
export namespace Ordem {
    export type StatusEnum = 'CAN' | 'EAT' | 'EDU' | 'FIN';
    export const StatusEnum = {
        CAN: 'CAN' as StatusEnum,
        EAT: 'EAT' as StatusEnum,
        EDU: 'EDU' as StatusEnum,
        FIN: 'FIN' as StatusEnum
    };
    export type TpOrdemEnum = 'ACAO' | 'CEND';
    export const TpOrdemEnum = {
        ACAO: 'ACAO' as TpOrdemEnum,
        CEND: 'CEND' as TpOrdemEnum,
        BAIXA: 'BAIXA' as TpOrdemEnum,
        HISTORICO: 'HISTORICO' as TpOrdemEnum
    };
}
